export { default } from './SearchInputs';
